import { Component } from '@angular/core';
import dataConfig from '../../../../assets/service-requests-data.json';
import { LoaderService } from '../../../core/services/loading.service';

@Component({
    selector: 'app-service-requests',
    templateUrl: './service-requests.component.html',
    standalone: false
})
export class ServiceRequestsComponent {
    serviceRequestsData1: any[] = dataConfig.listConfig.dataSource1;
    serviceRequestsData2: any[] = dataConfig.listConfig.dataSource2;
    programSRLinks: any;
    showAddNewWCPRequest: boolean = false;
    showAddSRequest: boolean = false;
    showSRequests: boolean = false;
    showAddWCRequest: boolean = false;
    public JSON = JSON;
    constructor(private loaderService: LoaderService) { }
    ngOnInit() {
        this.programSRLinks = JSON.parse(this.loaderService.getItem('serviceFunctionsLinks'));
        if (this.programSRLinks['Add New WC Posting Notice Request']) {
            this.showAddNewWCPRequest = true;
        }
        if (this.programSRLinks['Add New Policy Service Request']) {
            this.showAddSRequest = true;
        }
        if (this.programSRLinks['Service Requests']) {
            this.showSRequests = true;
        }
    }
}
